<template>
  <div class="d-flex align-items-center">
    <div class="side-frame-danger group-title">
      {{ $l('INDEX.tips_title_add_spec') || '增加多个规格' }}
    </div>
    <div>
      <b-button
        class="mr-2"
        size="sm"
        variant="outline-success"
        @click="$emit('openDetailDialog', { type: 'add' })"
        :disabled="disabled"
      >
        {{ $l('INDEX.btn_add') || '添加' }}
      </b-button>
      <!-- <b-button
        class="mr-2"
        size="sm"
        variant="outline-danger"
        @click="$emit('batchDel')"
        :disabled="disabled"
      >
        {{ this.$l('INDEX.INDEX.btn_delete') || '删除' }}
      </b-button> -->
    </div>
  </div>
</template>
<script>
export default {
  props: { disabled: { type: Boolean, default: false } }
}
</script>
